var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _path, _rect36, _g2, _mask, _path2, _mask2, _path3, _mask3, _path4, _mask4, _path5, _mask5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadFigure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 70,
    viewBox: "0 0 256 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1463_67328)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.944336,
    width: 110,
    height: 67.2222,
    rx: 2.22222,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.44434,
    width: 109,
    height: 66.2222,
    rx: 1.72222,
    stroke: "#E4E7EC"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.38867,
    y: 4.27783,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.38867,
    y: 13.1665,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.38867,
    y: 22.0557,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.38867,
    y: 30.9443,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.38867,
    y: 39.8335,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.38867,
    y: 48.7222,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.38867,
    y: 57.6113,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 4.27783,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 13.1665,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 22.0557,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 30.9443,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 39.8335,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 48.7222,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 57.6113,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6113,
    y: 4.27783,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6113,
    y: 13.1665,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6113,
    y: 22.0557,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6113,
    y: 30.9443,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6113,
    y: 39.8335,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6113,
    y: 48.7222,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6113,
    y: 57.6113,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 68.166,
    y: 4.27783,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 68.166,
    y: 13.1665,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 68.166,
    y: 22.0557,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 68.166,
    y: 30.9443,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 68.166,
    y: 39.8335,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 68.166,
    y: 48.7222,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 68.166,
    y: 57.6113,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2773,
    y: 4.27783,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2773,
    y: 13.1665,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2773,
    y: 22.0557,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2773,
    y: 30.9443,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2773,
    y: 39.8335,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2773,
    y: 48.7222,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2773,
    y: 57.6113,
    width: 18.8889,
    height: 6.66667,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.207 34.5558H131.79M131.79 34.5558L127.999 30.7642M131.79 34.5558L127.999 38.3475",
    stroke: "#98A2B3",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 67.2222,
    transform: "translate(144.5 0.944336)",
    fill: "#FCFCFD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1463_67328)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 0.944336,
    width: 110,
    height: 67.2222,
    rx: 2.22222,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 1.44434,
    width: 109,
    height: 66.2222,
    rx: 1.72222,
    stroke: "#F8F0FF"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-41-inside-1_1463_67328",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.5 14.9443C194.629 14.9443 189.925 16.7221 186.272 19.9439C182.618 23.1657 180.266 27.6101 179.657 32.443L184.419 33.0432C184.882 29.3703 186.67 25.9925 189.446 23.5439C192.223 21.0954 195.798 19.7443 199.5 19.7443V14.9443Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.5 14.9443C194.629 14.9443 189.925 16.7221 186.272 19.9439C182.618 23.1657 180.266 27.6101 179.657 32.443L184.419 33.0432C184.882 29.3703 186.67 25.9925 189.446 23.5439C192.223 21.0954 195.798 19.7443 199.5 19.7443V14.9443Z",
    fill: "#F8F0FF",
    stroke: "white",
    strokeWidth: 0.418295,
    mask: "url(#path-41-inside-1_1463_67328)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-42-inside-2_1463_67328",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.5 14.9443C203.723 14.9443 207.838 16.2814 211.255 18.7639C214.672 21.2465 217.215 24.747 218.521 28.7638L213.956 30.2471C212.964 27.1943 211.031 24.5339 208.434 22.6472C205.837 20.7605 202.71 19.7443 199.5 19.7443V14.9443Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.5 14.9443C203.723 14.9443 207.838 16.2814 211.255 18.7639C214.672 21.2465 217.215 24.747 218.521 28.7638L213.956 30.2471C212.964 27.1943 211.031 24.5339 208.434 22.6472C205.837 20.7605 202.71 19.7443 199.5 19.7443V14.9443Z",
    fill: "#4A1FB8",
    stroke: "white",
    strokeWidth: 0.418295,
    mask: "url(#path-42-inside-2_1463_67328)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-3_1463_67328",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.521 28.7638C219.66 32.2717 219.808 36.0264 218.947 39.6129C218.086 43.1994 216.25 46.4779 213.642 49.086C211.034 51.6941 207.755 53.5302 204.169 54.3912C200.582 55.2523 196.827 55.1048 193.319 53.965L194.803 49.4C197.469 50.2662 200.322 50.3783 203.048 49.7239C205.774 49.0695 208.265 47.6741 210.248 45.692C212.23 43.7098 213.625 41.2181 214.28 38.4924C214.934 35.7667 214.822 32.9131 213.956 30.2471L218.521 28.7638Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.521 28.7638C219.66 32.2717 219.808 36.0264 218.947 39.6129C218.086 43.1994 216.25 46.4779 213.642 49.086C211.034 51.6941 207.755 53.5302 204.169 54.3912C200.582 55.2523 196.827 55.1048 193.319 53.965L194.803 49.4C197.469 50.2662 200.322 50.3783 203.048 49.7239C205.774 49.0695 208.265 47.6741 210.248 45.692C212.23 43.7098 213.625 41.2181 214.28 38.4924C214.934 35.7667 214.822 32.9131 213.956 30.2471L218.521 28.7638Z",
    fill: "#6938EF",
    stroke: "white",
    strokeWidth: 0.418295,
    mask: "url(#path-43-inside-3_1463_67328)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-44-inside-4_1463_67328",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.319 53.965C189.303 52.6598 185.802 50.1166 183.32 46.6996L187.203 43.8783C189.09 46.4752 191.75 48.4081 194.803 49.4L193.319 53.965Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.319 53.965C189.303 52.6598 185.802 50.1166 183.32 46.6996L187.203 43.8783C189.09 46.4752 191.75 48.4081 194.803 49.4L193.319 53.965Z",
    fill: "#7A5AF8",
    stroke: "white",
    strokeWidth: 0.418295,
    mask: "url(#path-44-inside-4_1463_67328)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-45-inside-5_1463_67328",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.32 46.6996C180.33 42.5843 179.02 37.4842 179.658 32.4375L184.42 33.039C183.935 36.8746 184.93 40.7506 187.203 43.8783L183.32 46.6996Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.32 46.6996C180.33 42.5843 179.02 37.4842 179.658 32.4375L184.42 33.039C183.935 36.8746 184.93 40.7506 187.203 43.8783L183.32 46.6996Z",
    fill: "#9B8AFB",
    stroke: "white",
    strokeWidth: 0.418295,
    mask: "url(#path-45-inside-5_1463_67328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1463_67328",
    x: 0.388889,
    y: 0.38878,
    width: 112.222,
    height: 69.4444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.555556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.555556
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1463_67328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1463_67328",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1463_67328",
    x: 143.389,
    y: 0.38878,
    width: 112.222,
    height: 69.4444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.555556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.555556
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1463_67328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1463_67328",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFigure);
export default __webpack_public_path__ + "static/media/upload-figure.a7e0654586de8c2e7d8c05bf76391268.svg";
export { ForwardRef as ReactComponent };